import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

import classes from './RuleStatus.module.css';

const ToolTips = {
    Running: 'Recalculating'
};

const RuleStatus = ({ rule }) => {
    const title = ToolTips[rule.recalculationStatus];
    return (
        <Tooltip
            className={classes.root}
            placement="top"
            title={title}
        >
            <div>
                <CircularProgress size={20} />
            </div>
        </Tooltip>
    );
};

export default RuleStatus;
